<app-payment-summary [amountDetails]="amountDetails"></app-payment-summary>
@if(isLoader) {
  <div class="fixed inset-0 bg-opacity-50 backdrop-blur-sm flex items-center justify-center" style="z-index: 999"
    role="status" aria-live="polite" aria-label="Loading registration">
    <mat-progress-spinner class="!h-[50px] !w-[50px]" mode="indeterminate" aria-label="Loading" />
  </div>
}
<div id='custom-html' [class.payment-loading]="isLoader" role="region" aria-label="Payment processing"></div>
